// Lightweight celebration helpers — fires confetti for milestone moments.
// Keep effects subtle; we want delight, not noise.
import confetti from 'canvas-confetti';

const PALETTE = ['#9333ea', '#f97316', '#fbbf24', '#10b981', '#3b82f6'];

/** Burst from a single point (default: just below center). */
export function celebrate(originY = 0.7) {
  confetti({
    particleCount: 80,
    spread: 70,
    origin: { y: originY },
    colors: PALETTE,
    scalar: 0.9,
    ticks: 200,
  });
}

/** Bigger, two-side cannon for major milestones (course complete, exam pass). */
export function bigCelebrate() {
  const end = Date.now() + 600;
  const fire = () => {
    confetti({
      particleCount: 6,
      angle: 60,
      spread: 55,
      origin: { x: 0, y: 0.7 },
      colors: PALETTE,
    });
    confetti({
      particleCount: 6,
      angle: 120,
      spread: 55,
      origin: { x: 1, y: 0.7 },
      colors: PALETTE,
    });
    if (Date.now() < end) requestAnimationFrame(fire);
  };
  fire();
}

/** Subtle sparkle from an element — pass a DOM ref's bounding rect. */
export function sparkleFrom(el) {
  if (!el) return celebrate();
  const rect = el.getBoundingClientRect();
  const x = (rect.left + rect.width / 2) / window.innerWidth;
  const y = (rect.top + rect.height / 2) / window.innerHeight;
  confetti({
    particleCount: 40,
    spread: 50,
    origin: { x, y },
    colors: PALETTE,
    scalar: 0.7,
    ticks: 150,
  });
}
